import React from 'react'
import { ModalWrapper } from '../../wrapperComponents/page'
import { Form, FormInstance } from 'antd'
import formatMsg from '../../../util/formatMsg'
import TextArea from 'antd/es/input/TextArea';

interface AbsentModalProps {
    form: FormInstance,
    isAbsentNoteModalOpen: boolean;
    handleAbsentNoteOk: any;
    handleAbsentNoteCancel: any;
}

const AbsentNoteModal = (props: AbsentModalProps) => {

    const {
        form,
        isAbsentNoteModalOpen,
        handleAbsentNoteOk,
        handleAbsentNoteCancel
    } = props;

    return (
        <ModalWrapper
            open={isAbsentNoteModalOpen}
            title={formatMsg("addAnAbsentNote")}
            onOk={handleAbsentNoteOk}
            onCancel={handleAbsentNoteCancel}
            cancelText={formatMsg("new.skip")}
            okText={formatMsg("save")}
            maskClosable={false}
            closable={false}
        >
            <Form
                form={form}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
            >
                <div
                    style={{ padding: '15px 0px 8px 0px' }}
                >
                    <Form.Item
                        name={'absentNote'}
                        rules={[{ required: false, message: null }]}
                        className={'custom-form-item-label-margin'}
                    >
                        <TextArea
                            placeholder={formatMsg('yourDescGoesHere')}
                            rows={5}
                            showCount={true}
                            maxLength={100}
                        />
                    </Form.Item>
                </div>
            </Form>
        </ModalWrapper>
    )
}

export default AbsentNoteModal